Minified production bundle. Original unminified theme sources were not included with this static landing page export.